import type { FrontModule } from "@nabble/sdk";
import { lazy } from "react";

const WebsiteEditorPage = lazy(() => import("./pages/WebsiteEditorPage"));
const SitePage = lazy(() => import("./pages/SitePage"));

export const websiteModule: FrontModule = {
  id: "website",
  version: "0.1.0",
  permission: "website.edit",
  label: "Website",
  icon: "globe",
  description: "Edit the company's public website together and publish it when it's ready.",
  routes: [{ path: "/website", Component: WebsiteEditorPage }],
  // The public website: /p/website/ here, and the root of the main domain (shell/site.html).
  publicRoutes: [
    { path: "", Component: SitePage },
    { path: "servicios/:slug", Component: SitePage },
    { path: "privacidad", Component: SitePage },
  ],
  menu: [
    {
      id: "website.editor",
      label: "Website",
      icon: "globe",
      path: "/website",
      permission: "website.edit",
      description: "Edit and publish the public website",
    },
  ],
};

export default websiteModule;
